import { CONSTANTS, HELPER, ROUTE_CONSTANTS, PRODUCT_HELPER } from '../../../utils'

function CATALOG_REDIRECTION_RULE(maximum_purchase_limit, product, history) {
	if (product?.user_journey === CONSTANTS.PRODUCT_JOURNEYS.DIRECT_CHECKOUT) {
		if (HELPER.isNotEmpty(product?.active_variants) && product?.active_variants.length > 0) {
			if (product?.has_variants === 0) {
				product.selected_variant = PRODUCT_HELPER.GET_DEFAULT_VARIANT(product)
				PRODUCT_HELPER.ADD_PRODUCT_TO_CART(product, CONSTANTS.ADD_QTY, 1, maximum_purchase_limit)
				history.push(ROUTE_CONSTANTS.CART)
			} else {
				if (product?.active_variants.length === 1) {
					product.selected_variant = PRODUCT_HELPER.GET_DEFAULT_VARIANT(product)
					PRODUCT_HELPER.ADD_PRODUCT_TO_CART(product, CONSTANTS.ADD_QTY, 1, maximum_purchase_limit)
					history.push(ROUTE_CONSTANTS.CART)
				} else if (product?.active_variants.length > 1) {
					PRODUCT_HELPER.PRODUCT_SELECTION(product)
				}
			}
		} else if (HELPER.isEmpty(product?.active_variants) && product?.has_variants === 0) {
			product.selected_variant = PRODUCT_HELPER.GET_DEFAULT_VARIANT(product)
			PRODUCT_HELPER.ADD_PRODUCT_TO_CART(product, CONSTANTS.ADD_QTY, 1, maximum_purchase_limit)
			history.push(ROUTE_CONSTANTS.CART)
		}
	} else if (product?.user_journey === CONSTANTS.PRODUCT_JOURNEYS.CATALOG_WITHOUT_PRODUCT) {
		product = {}
	} else if (product?.user_journey === CONSTANTS.PRODUCT_JOURNEYS.CATALOG_WITH_PRODUCT) {
		if (product?.has_variants === 0) {
			product.selected_variant = PRODUCT_HELPER.GET_DEFAULT_VARIANT(product)
			PRODUCT_HELPER.ADD_PRODUCT_TO_CART(product, CONSTANTS.ADD_QTY, 1, maximum_purchase_limit)
		} else {
			if (product?.active_variants.length === 1) {
				product.selected_variant = PRODUCT_HELPER.GET_DEFAULT_VARIANT(product)
				PRODUCT_HELPER.ADD_PRODUCT_TO_CART(product, CONSTANTS.ADD_QTY, 1, maximum_purchase_limit)
			} else if (product?.active_variants.length > 1) {
				PRODUCT_HELPER.PRODUCT_SELECTION(product)
			}
		}
		history.push(history.location.pathname)
	}
	return product
}

const REDIRECTION_RULE = {
	CATALOG_REDIRECTION_RULE,
}
export default REDIRECTION_RULE
